import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mantine/core';
import { AddToHomescreenPrompt } from '../common/AddToHomescreen/AddToHomescreenPrompt';

const Home = () => {
  const [promptable, promptToInstall, isInstalled] = AddToHomescreenPrompt();
  const navigate = useNavigate();

  useEffect(() => {
    if (!promptable || isInstalled) {
      navigate('new-access-ticket');
    }
  }, [isInstalled, promptable, navigate]);

  return <>{promptable && !isInstalled && <Button onClick={promptToInstall}>Install as an App</Button>}</>;
};

export default Home;
